import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const Parameter = Loader(lazy(() => import('content/management/Parameter')));

const registerRoutes = [
  {
    path: '',
    element: <Navigate to="register" replace />
  },
  {
    path: '',
    children: [
      {
        path: '',
        element: <Navigate to="parameter" replace />
      },
      {
        path: 'parameter',
        children: [
          {
            path: '',
            element: <Navigate to="list" replace />
          },
          {
            path: 'list',
            element: <Parameter />
          }
        ]
      }
    ]
  }
];

export default registerRoutes;
